import * as r from "react";
import { j as n } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { T as ae } from "../../chunks/Text.BGhoO_e3.js";
import * as ke from "react-dom";
import { c as Ve, u as Ke, a as R } from "../../chunks/index.stoqs9MZ.js";
import { u as ue } from "../../chunks/index.B4ZV02se.js";
import { c as $e } from "../../chunks/index.BW3XI7yS.js";
import { B as He, R as We } from "../../chunks/index.DNGle7LJ.js";
import { P as Ue } from "../../chunks/index.RcubEhGW.js";
import { P as Xe } from "../../chunks/index.TrmYLGk6.js";
import { P as I, d as Ye } from "../../chunks/index.DMLWxr4u.js";
import { V as de } from "../../chunks/index.BkBvp-m6.js";
import { c as le } from "../../chunks/index.C4-GUKyp.js";
import { F as Be } from "../../chunks/X20.BXgaZkFp.js";
import { c as _ } from "../../chunks/index.CxSWpsOB.js";
const qe = 5, ze = 3e3;
let z = 0;
function Ge() {
  return z = (z + 1) % Number.MAX_SAFE_INTEGER, z.toString();
}
const G = /* @__PURE__ */ new Map(), ie = (e) => {
  if (G.has(e))
    return;
  const t = setTimeout(() => {
    G.delete(e), M({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, ze);
  G.set(e, t);
}, Qe = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, qe)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((s) => s.id === t.toast.id ? {
          ...s,
          ...t.toast
        } : s)
      };
    case "DISMISS_TOAST": {
      const {
        toastId: s
      } = t;
      return s ? ie(s) : e.toasts.forEach((o) => {
        ie(o.id);
      }), {
        ...e,
        toasts: e.toasts.map((o) => o.id === s || s === void 0 ? {
          ...o,
          open: !1
        } : o)
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((s) => s.id !== t.toastId)
      };
  }
}, U = [];
let X = {
  toasts: []
};
function M(e) {
  X = Qe(X, e), U.forEach((t) => {
    t(X);
  });
}
function Je({
  ...e
}) {
  const t = Ge(), s = (a) => M({
    type: "UPDATE_TOAST",
    toast: {
      ...a,
      id: t
    }
  }), o = () => {
    M({
      type: "DISMISS_TOAST",
      toastId: t
    });
  };
  return M({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (a) => {
        a || o(), e.onOpenChange?.(a);
      }
    }
  }), {
    id: t,
    dismiss: o,
    update: s
  };
}
function Ze() {
  const [e, t] = r.useState(X);
  return r.useEffect(() => (U.push(t), () => {
    const s = U.indexOf(t);
    s > -1 && U.splice(s, 1);
  }), [e]), {
    ...e,
    toast: Je,
    dismiss: (s) => M({
      type: "DISMISS_TOAST",
      toastId: s
    })
  };
}
function Y(e) {
  const t = r.useRef(e);
  return r.useEffect(() => {
    t.current = e;
  }), r.useMemo(() => (...s) => t.current?.(...s), []);
}
var et = globalThis?.document ? r.useLayoutEffect : () => {
}, te = "ToastProvider", [se, tt, st] = $e("Toast"), [pe, Mt] = Ve("Toast", [st]), [ot, B] = pe(te), fe = (e) => {
  const {
    __scopeToast: t,
    label: s = "Notification",
    duration: o = 5e3,
    swipeDirection: a = "right",
    swipeThreshold: d = 50,
    children: l
  } = e, [w, T] = r.useState(null), [i, x] = r.useState(0), v = r.useRef(!1), S = r.useRef(!1);
  return s.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${te}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ n.jsx(se.Provider, { scope: t, children: /* @__PURE__ */ n.jsx(
    ot,
    {
      scope: t,
      label: s,
      duration: o,
      swipeDirection: a,
      swipeThreshold: d,
      toastCount: i,
      viewport: w,
      onViewportChange: T,
      onToastAdd: r.useCallback(() => x((b) => b + 1), []),
      onToastRemove: r.useCallback(() => x((b) => b - 1), []),
      isFocusedToastEscapeKeyDownRef: v,
      isClosePausedRef: S,
      children: l
    }
  ) });
};
fe.displayName = te;
var we = "ToastViewport", rt = ["F8"], J = "toast.viewportPause", Z = "toast.viewportResume", me = r.forwardRef(
  (e, t) => {
    const {
      __scopeToast: s,
      hotkey: o = rt,
      label: a = "Notifications ({hotkey})",
      ...d
    } = e, l = B(we, s), w = tt(s), T = r.useRef(null), i = r.useRef(null), x = r.useRef(null), v = r.useRef(null), S = ue(t, v, l.onViewportChange), b = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), A = l.toastCount > 0;
    r.useEffect(() => {
      const u = (y) => {
        o.length !== 0 && o.every((m) => y[m] || y.code === m) && v.current?.focus();
      };
      return document.addEventListener("keydown", u), () => document.removeEventListener("keydown", u);
    }, [o]), r.useEffect(() => {
      const u = T.current, y = v.current;
      if (A && u && y) {
        const f = () => {
          if (!l.isClosePausedRef.current) {
            const E = new CustomEvent(J);
            y.dispatchEvent(E), l.isClosePausedRef.current = !0;
          }
        }, m = () => {
          if (l.isClosePausedRef.current) {
            const E = new CustomEvent(Z);
            y.dispatchEvent(E), l.isClosePausedRef.current = !1;
          }
        }, h = (E) => {
          !u.contains(E.relatedTarget) && m();
        }, g = () => {
          u.contains(document.activeElement) || m();
        };
        return u.addEventListener("focusin", f), u.addEventListener("focusout", h), u.addEventListener("pointermove", f), u.addEventListener("pointerleave", g), window.addEventListener("blur", f), window.addEventListener("focus", m), () => {
          u.removeEventListener("focusin", f), u.removeEventListener("focusout", h), u.removeEventListener("pointermove", f), u.removeEventListener("pointerleave", g), window.removeEventListener("blur", f), window.removeEventListener("focus", m);
        };
      }
    }, [A, l.isClosePausedRef]);
    const p = r.useCallback(
      ({ tabbingDirection: u }) => {
        const f = w().map((m) => {
          const h = m.ref.current, g = [h, ...vt(h)];
          return u === "forwards" ? g : g.reverse();
        });
        return (u === "forwards" ? f.reverse() : f).flat();
      },
      [w]
    );
    return r.useEffect(() => {
      const u = v.current;
      if (u) {
        const y = (f) => {
          const m = f.altKey || f.ctrlKey || f.metaKey;
          if (f.key === "Tab" && !m) {
            const g = document.activeElement, E = f.shiftKey;
            if (f.target === u && E) {
              i.current?.focus();
              return;
            }
            const F = p({ tabbingDirection: E ? "backwards" : "forwards" }), V = F.findIndex((N) => N === g);
            Q(F.slice(V + 1)) ? f.preventDefault() : E ? i.current?.focus() : x.current?.focus();
          }
        };
        return u.addEventListener("keydown", y), () => u.removeEventListener("keydown", y);
      }
    }, [w, p]), /* @__PURE__ */ n.jsxs(
      He,
      {
        ref: T,
        role: "region",
        "aria-label": a.replace("{hotkey}", b),
        tabIndex: -1,
        style: { pointerEvents: A ? void 0 : "none" },
        children: [
          A && /* @__PURE__ */ n.jsx(
            ee,
            {
              ref: i,
              onFocusFromOutsideViewport: () => {
                const u = p({
                  tabbingDirection: "forwards"
                });
                Q(u);
              }
            }
          ),
          /* @__PURE__ */ n.jsx(se.Slot, { scope: s, children: /* @__PURE__ */ n.jsx(I.ol, { tabIndex: -1, ...d, ref: S }) }),
          A && /* @__PURE__ */ n.jsx(
            ee,
            {
              ref: x,
              onFocusFromOutsideViewport: () => {
                const u = p({
                  tabbingDirection: "backwards"
                });
                Q(u);
              }
            }
          )
        ]
      }
    );
  }
);
me.displayName = we;
var Te = "ToastFocusProxy", ee = r.forwardRef(
  (e, t) => {
    const { __scopeToast: s, onFocusFromOutsideViewport: o, ...a } = e, d = B(Te, s);
    return /* @__PURE__ */ n.jsx(
      de,
      {
        tabIndex: 0,
        ...a,
        ref: t,
        style: { position: "fixed" },
        onFocus: (l) => {
          const w = l.relatedTarget;
          !d.viewport?.contains(w) && o();
        }
      }
    );
  }
);
ee.displayName = Te;
var L = "Toast", nt = "toast.swipeStart", at = "toast.swipeMove", it = "toast.swipeCancel", ct = "toast.swipeEnd", ve = r.forwardRef(
  (e, t) => {
    const { forceMount: s, open: o, defaultOpen: a, onOpenChange: d, ...l } = e, [w, T] = Ke({
      prop: o,
      defaultProp: a ?? !0,
      onChange: d,
      caller: L
    });
    return /* @__PURE__ */ n.jsx(Xe, { present: s || w, children: /* @__PURE__ */ n.jsx(
      lt,
      {
        open: w,
        ...l,
        ref: t,
        onClose: () => T(!1),
        onPause: Y(e.onPause),
        onResume: Y(e.onResume),
        onSwipeStart: R(e.onSwipeStart, (i) => {
          i.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: R(e.onSwipeMove, (i) => {
          const { x, y: v } = i.detail.delta;
          i.currentTarget.setAttribute("data-swipe", "move"), i.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x}px`), i.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${v}px`);
        }),
        onSwipeCancel: R(e.onSwipeCancel, (i) => {
          i.currentTarget.setAttribute("data-swipe", "cancel"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), i.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), i.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: R(e.onSwipeEnd, (i) => {
          const { x, y: v } = i.detail.delta;
          i.currentTarget.setAttribute("data-swipe", "end"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), i.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x}px`), i.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${v}px`), T(!1);
        })
      }
    ) });
  }
);
ve.displayName = L;
var [ut, dt] = pe(L, {
  onClose() {
  }
}), lt = r.forwardRef(
  (e, t) => {
    const {
      __scopeToast: s,
      type: o = "foreground",
      duration: a,
      open: d,
      onClose: l,
      onEscapeKeyDown: w,
      onPause: T,
      onResume: i,
      onSwipeStart: x,
      onSwipeMove: v,
      onSwipeCancel: S,
      onSwipeEnd: b,
      ...A
    } = e, p = B(L, s), [u, y] = r.useState(null), f = ue(t, (c) => y(c)), m = r.useRef(null), h = r.useRef(null), g = a || p.duration, E = r.useRef(0), D = r.useRef(g), k = r.useRef(0), { onToastAdd: F, onToastRemove: V } = p, N = Y(() => {
      u?.contains(document.activeElement) && p.viewport?.focus(), l();
    }), K = r.useCallback(
      (c) => {
        !c || c === 1 / 0 || (window.clearTimeout(k.current), E.current = (/* @__PURE__ */ new Date()).getTime(), k.current = window.setTimeout(N, c));
      },
      [N]
    );
    r.useEffect(() => {
      const c = p.viewport;
      if (c) {
        const P = () => {
          K(D.current), i?.();
        }, C = () => {
          const O = (/* @__PURE__ */ new Date()).getTime() - E.current;
          D.current = D.current - O, window.clearTimeout(k.current), T?.();
        };
        return c.addEventListener(J, C), c.addEventListener(Z, P), () => {
          c.removeEventListener(J, C), c.removeEventListener(Z, P);
        };
      }
    }, [p.viewport, g, T, i, K]), r.useEffect(() => {
      d && !p.isClosePausedRef.current && K(g);
    }, [d, g, p.isClosePausedRef, K]), r.useEffect(() => (F(), () => V()), [F, V]);
    const re = r.useMemo(() => u ? Re(u) : null, [u]);
    return p.viewport ? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
      re && /* @__PURE__ */ n.jsx(
        pt,
        {
          __scopeToast: s,
          role: "status",
          "aria-live": o === "foreground" ? "assertive" : "polite",
          children: re
        }
      ),
      /* @__PURE__ */ n.jsx(ut, { scope: s, onClose: N, children: ke.createPortal(
        /* @__PURE__ */ n.jsx(se.ItemSlot, { scope: s, children: /* @__PURE__ */ n.jsx(
          We,
          {
            asChild: !0,
            onEscapeKeyDown: R(w, () => {
              p.isFocusedToastEscapeKeyDownRef.current || N(), p.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ n.jsx(
              I.li,
              {
                tabIndex: 0,
                "data-state": d ? "open" : "closed",
                "data-swipe-direction": p.swipeDirection,
                ...A,
                ref: f,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: R(e.onKeyDown, (c) => {
                  c.key === "Escape" && (w?.(c.nativeEvent), c.nativeEvent.defaultPrevented || (p.isFocusedToastEscapeKeyDownRef.current = !0, N()));
                }),
                onPointerDown: R(e.onPointerDown, (c) => {
                  c.button === 0 && (m.current = { x: c.clientX, y: c.clientY });
                }),
                onPointerMove: R(e.onPointerMove, (c) => {
                  if (!m.current) return;
                  const P = c.clientX - m.current.x, C = c.clientY - m.current.y, O = !!h.current, j = ["left", "right"].includes(p.swipeDirection), $ = ["left", "up"].includes(p.swipeDirection) ? Math.min : Math.max, Me = j ? $(0, P) : 0, Le = j ? 0 : $(0, C), q = c.pointerType === "touch" ? 10 : 2, H = { x: Me, y: Le }, ne = { originalEvent: c, delta: H };
                  O ? (h.current = H, W(at, v, ne, {
                    discrete: !1
                  })) : ce(H, p.swipeDirection, q) ? (h.current = H, W(nt, x, ne, {
                    discrete: !1
                  }), c.target.setPointerCapture(c.pointerId)) : (Math.abs(P) > q || Math.abs(C) > q) && (m.current = null);
                }),
                onPointerUp: R(e.onPointerUp, (c) => {
                  const P = h.current, C = c.target;
                  if (C.hasPointerCapture(c.pointerId) && C.releasePointerCapture(c.pointerId), h.current = null, m.current = null, P) {
                    const O = c.currentTarget, j = { originalEvent: c, delta: P };
                    ce(P, p.swipeDirection, p.swipeThreshold) ? W(ct, b, j, {
                      discrete: !0
                    }) : W(
                      it,
                      S,
                      j,
                      {
                        discrete: !0
                      }
                    ), O.addEventListener("click", ($) => $.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        p.viewport
      ) })
    ] }) : null;
  }
), pt = (e) => {
  const { __scopeToast: t, children: s, ...o } = e, a = B(L, t), [d, l] = r.useState(!1), [w, T] = r.useState(!1);
  return mt(() => l(!0)), r.useEffect(() => {
    const i = window.setTimeout(() => T(!0), 1e3);
    return () => window.clearTimeout(i);
  }, []), w ? null : /* @__PURE__ */ n.jsx(Ue, { asChild: !0, children: /* @__PURE__ */ n.jsx(de, { ...o, children: d && /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    a.label,
    " ",
    s
  ] }) }) });
}, ft = "ToastTitle", xe = r.forwardRef(
  (e, t) => {
    const { __scopeToast: s, ...o } = e;
    return /* @__PURE__ */ n.jsx(I.div, { ...o, ref: t });
  }
);
xe.displayName = ft;
var wt = "ToastDescription", Ee = r.forwardRef(
  (e, t) => {
    const { __scopeToast: s, ...o } = e;
    return /* @__PURE__ */ n.jsx(I.div, { ...o, ref: t });
  }
);
Ee.displayName = wt;
var ye = "ToastAction", he = r.forwardRef(
  (e, t) => {
    const { altText: s, ...o } = e;
    return s.trim() ? /* @__PURE__ */ n.jsx(be, { altText: s, asChild: !0, children: /* @__PURE__ */ n.jsx(oe, { ...o, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${ye}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
he.displayName = ye;
var ge = "ToastClose", oe = r.forwardRef(
  (e, t) => {
    const { __scopeToast: s, ...o } = e, a = dt(ge, s);
    return /* @__PURE__ */ n.jsx(be, { asChild: !0, children: /* @__PURE__ */ n.jsx(
      I.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: R(e.onClick, a.onClose)
      }
    ) });
  }
);
oe.displayName = ge;
var be = r.forwardRef((e, t) => {
  const { __scopeToast: s, altText: o, ...a } = e;
  return /* @__PURE__ */ n.jsx(
    I.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": o || void 0,
      ...a,
      ref: t
    }
  );
});
function Re(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((o) => {
    if (o.nodeType === o.TEXT_NODE && o.textContent && t.push(o.textContent), Tt(o)) {
      const a = o.ariaHidden || o.hidden || o.style.display === "none", d = o.dataset.radixToastAnnounceExclude === "";
      if (!a)
        if (d) {
          const l = o.dataset.radixToastAnnounceAlt;
          l && t.push(l);
        } else
          t.push(...Re(o));
    }
  }), t;
}
function W(e, t, s, { discrete: o }) {
  const a = s.originalEvent.currentTarget, d = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: s });
  t && a.addEventListener(e, t, { once: !0 }), o ? Ye(a, d) : a.dispatchEvent(d);
}
var ce = (e, t, s = 0) => {
  const o = Math.abs(e.x), a = Math.abs(e.y), d = o > a;
  return t === "left" || t === "right" ? d && o > s : !d && a > s;
};
function mt(e = () => {
}) {
  const t = Y(e);
  et(() => {
    let s = 0, o = 0;
    return s = window.requestAnimationFrame(() => o = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(s), window.cancelAnimationFrame(o);
    };
  }, [t]);
}
function Tt(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function vt(e) {
  const t = [], s = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const a = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || a ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; s.nextNode(); ) t.push(s.currentNode);
  return t;
}
function Q(e) {
  const t = document.activeElement;
  return e.some((s) => s === t ? !0 : (s.focus(), document.activeElement !== t));
}
var xt = fe, Pe = me, Ce = ve, Se = xe, Ae = Ee, Ne = he, Ie = oe;
const Et = xt, _e = r.forwardRef(({
  className: e,
  ...t
}, s) => /* @__PURE__ */ n.jsx(Pe, { ref: s, className: _("tw-fixed tw-gap-y-8 tw-top-0 tw-z-[100] tw-flex tw-max-h-screen tw-w-full tw-flex-col-reverse tw-p-16 sm:tw-bottom-0 tw-right-0 sm:tw-top-auto sm:tw-flex-col md:tw-max-w-[420px]", e), ...t }));
_e.displayName = Pe.displayName;
const yt = le("tw-group tw-pr-16 tw-pl-16 tw-py-14 tw-gap-x-14 tw-pointer-events-auto tw-relative tw-bg-base-white tw-flex tw-w-full tw-items-center tw-justify-between tw-overflow-hidden tw-rounded-8 tw-shadow-xl tw-transition-all data-[swipe=cancel]:tw-translate-x-0 data-[swipe=end]:tw-translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:tw-translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:tw-transition-none data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[swipe=end]:tw-animate-out data-[state=closed]:tw-fade-out-80 data-[state=closed]:tw-slide-out-to-right-full data-[state=open]:tw-slide-in-from-top-full data-[state=open]:sm:tw-slide-in-from-bottom-full", {
  variants: {
    variant: {
      white: "tw-bg-base-white",
      black: "tw-bg-gray-900 tw-text-base-white",
      destructive: "tw-text-red-900 tw-bg-red-200",
      success: "tw-text-green-900 tw-bg-green-100",
      brand: "tw-text-purple-800 tw-bg-purple-200"
    }
  },
  defaultVariants: {
    variant: "white"
  }
}), De = r.forwardRef(({
  className: e,
  variant: t,
  ...s
}, o) => /* @__PURE__ */ n.jsx(Ce, { ref: o, className: _(yt({
  variant: t
}), e), ...s }));
De.displayName = Ce.displayName;
const ht = r.forwardRef(({
  className: e,
  ...t
}, s) => /* @__PURE__ */ n.jsx(Ne, { ref: s, className: _("tw-inline-flex tw-h-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-border tw-bg-transparent tw-px-3 tw-text-sm tw-font-medium tw-ring-offset-background tw-transition-colors hover:tw-bg-secondary focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50 group-[.destructive]:tw-border-muted/40 group-[.destructive]:hover:tw-border-destructive/30 group-[.destructive]:hover:tw-bg-destructive group-[.destructive]:hover:tw-text-destructive-foreground group-[.destructive]:focus:tw-ring-destructive", e), ...t }));
ht.displayName = Ne.displayName;
const gt = le("tw-flex tw-align-center tw-rounded-2 focus:tw-outline-none focus:tw-ring-2", {
  variants: {
    variant: {
      white: "",
      black: "tw-text-base-white",
      destructive: "tw-text-red-900",
      success: "tw-text-green-900",
      brand: "tw-text-purple-800"
    }
  },
  defaultVariants: {
    variant: "white"
  }
}), Fe = r.forwardRef(({
  className: e,
  variant: t,
  ...s
}, o) => /* @__PURE__ */ n.jsx(Ie, { ref: o, className: _(gt({
  variant: t
}), e), "toast-close": "", ...s, children: /* @__PURE__ */ n.jsx(Be, {}) }));
Fe.displayName = Ie.displayName;
const Oe = r.forwardRef(({
  className: e,
  ...t
}, s) => /* @__PURE__ */ n.jsx(Se, { ref: s, className: _(e), ...t }));
Oe.displayName = Se.displayName;
const je = r.forwardRef(({
  className: e,
  ...t
}, s) => /* @__PURE__ */ n.jsx(Ae, { ref: s, className: _("tw-text-sm tw-opacity-90", e), ...t }));
je.displayName = Ae.displayName;
const Lt = ({
  viewportProps: e = {},
  providerProps: t = {},
  titleProps: s = {},
  descriptionProps: o = {}
}) => {
  const {
    toasts: a,
    dismiss: d
  } = Ze();
  return /* @__PURE__ */ n.jsxs(Et, { ...t, children: [
    a.map(function({
      id: l,
      title: w,
      description: T,
      action: i,
      duration: x = 3e3,
      variant: v,
      ...S
    }) {
      return /* @__PURE__ */ n.jsxs(De, { variant: v, duration: x, ...S, children: [
        /* @__PURE__ */ n.jsxs("div", { className: "tw-grid tw-gap-1", children: [
          w && /* @__PURE__ */ n.jsx(Oe, { ...s, children: /* @__PURE__ */ n.jsx(ae, { typeface: "headline-2-m", children: w }) }),
          T && /* @__PURE__ */ n.jsx(je, { ...o, children: /* @__PURE__ */ n.jsx(ae, { typeface: "body-2-m", children: T }) })
        ] }),
        /* @__PURE__ */ n.jsx("div", { role: "button", onClick: () => d(l), tabIndex: 0, onKeyDown: (b) => {
          (b.key === "Enter" || b.key === " ") && d(l);
        }, children: i || /* @__PURE__ */ n.jsx(Fe, { variant: v }) })
      ] }, l);
    }),
    /* @__PURE__ */ n.jsx(_e, { ...e })
  ] });
};
export {
  Lt as Toaster,
  Qe as reducer,
  Je as toast,
  Ze as useToast
};
//# sourceMappingURL=index.js.map
